"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _config = require("./config");
var _default = (config, instance) => ({
  create(token) {
    const AxiosAuthInstance = (0, _config.makeAuthInstance)(config);
    return AxiosAuthInstance.post('/session', {
      idToken: token
    }, {
      baseURL: config.apiPrefixes.pcasSession
    });
  },
  get(retain = true) {
    return instance.get('/session/current', {
      params: {
        retain
      },
      baseURL: config.apiPrefixes.pcasSession
    });
  },
  remove(endpointURL, method, options) {
    return instance[method](endpointURL, options);
  }
});
exports.default = _default;